import React, { useState, useEffect } from 'react';

const DailyQuoteReminder = ({ onGenerateQuote, darkMode }) => {
  const [showReminder, setShowReminder] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('lastQuoteDate');
    const today = new Date().toDateString();
    
    if (saved) {
      if (saved !== today) {
        setShowReminder(true);
      }
    } else {
      setShowReminder(true);
    }
  }, []);

  const handleGenerateDailyQuote = () => {
    const today = new Date().toDateString();
    localStorage.setItem('lastQuoteDate', today);
    setShowReminder(false);
    onGenerateQuote('motivation', 'sk');
  };

  const dismissReminder = () => {
    setShowReminder(false);
  };

  if (!showReminder) {
    return null;
  }

  return (
    <div className="daily-reminder">
      <div className="reminder-content">
        <div className="reminder-icon">🌅</div>
        <div className="reminder-text">
          <h3>Dobrý deň!</h3>
          <p>Začnite svoj deň s motivačným citátom</p>
        </div>
        <div className="reminder-actions">
          <button 
            onClick={handleGenerateDailyQuote}
            className="reminder-button primary"
          >
            ✨ Generovať
          </button>
          <button 
            onClick={dismissReminder}
            className="reminder-button secondary"
          >
            ❌ Zavrieť
          </button>
        </div>
      </div>
    </div>
  );
};

export default DailyQuoteReminder;
